import { NgModule } from '@angular/core';
import { ZuperSplashScreenService } from './splash-screen.service';

@NgModule({
    providers: [
        ZuperSplashScreenService
    ]
})
export class ZuperSplashScreenModule
{
    /**
     * Constructor
     */
    constructor(private _zuperSplashScreenService: ZuperSplashScreenService)
    {
    }
}
